import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { WebinarLink } from './WebinarLink';
export const FAQ = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-62">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <section className="mb-10" data-id="element-63">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-64">
        Waarom dit anders is dan andere trainingsmethoden
      </h2>
      <p className="mb-6 leading-relaxed" data-id="element-65">
        Traditionele hondentraining draait om gehoorzaamheid: je hond leren doen
        wat jij wilt. Amee's methode draait om begrip en samenwerken: Je hond
        leren begrijpen en hoe hij je zorgt dat hij jou begrijpt.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-66">
        "Het verschil is enorm," legt ze uit. "Bij training probeer je gedrag te
        forceren. Als je leert communiceren dan begrijp je elkaar en kan je
        samenwerken met je hond. Bovendien wordt je hond er veel relaxter van."
      </p>
      <div className="space-y-6" data-id="element-67">
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-68">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-69">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-70" />
            <h3 className="font-bold" data-id="element-71">
              "Is er een specifiek moment waarop het kwartje valt?"
            </h3>
          </div>
          <div className="p-4" data-id="element-72">
            <p className="leading-relaxed" data-id="element-73">
              Er is een specifiek moment tijdens elk webinar dat Amee het
              "omslagpunt" noemt. Meestal rond minuut 20, wanneer ze een aantal
              misvattingen over dominantie uit de wereld helpt.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-74">
              "Dan zie ik in de chat dat het kwartje valt," vertelt ze. "Mensen
              typen dingen als 'OMG, daarom doet hij dat!' of 'Dit verklaart
              alles!' Dat is het moment waarop ze overschakelen van problemen
              zien naar communicatie begrijpen."
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-75">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-76">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-77" />
            <h3 className="font-bold" data-id="element-78">
              "Wat zeggen mensen één week na het{' '}
              {replaceWebinarWithLink('webinar')}?"
            </h3>
          </div>
          <div className="p-4" data-id="element-79">
            <p className="leading-relaxed" data-id="element-80">
              De echte test van de "90-minuten transformatie" komt in de dagen
              na het webinar. Kunnen mensen de nieuwe inzichten toepassen? Maken
              ze echt verschil?
            </p>
            <p className="leading-relaxed mt-2" data-id="element-81">
              "Binnen drie dagen waren onze wandelingen compleet veranderd,"
              vertelt Jeroen uit Rotterdam. "In plaats van Max corrigeren ging
              ik luisteren naar wat hij probeerde te zeggen. Nu zijn wandelingen
              ontspannen in plaats van stressvol."
            </p>
            <p className="leading-relaxed mt-2" data-id="element-82">
              Emma uit Gent: "Het grappige is dat Mila niet veranderd is - ik
              begrijp haar gewoon beter. Waardoor zij zich ook rustiger voelt.
              Het is een opwaartse spiraal."
            </p>
          </div>
        </div>
      </div>
    </section>;
};